import React from "react";
import HomeIcon from "../common/HomeIcon";
import Mantra1_3 from "../Mantra1/mantra1_3";
import { userDetailStore, listApiStore } from "../../config/store";
import $ from "jquery";
import { Html2CanvasFunction, processShare } from "../../utils/NewHelper";
import {
  dataURLToBlob,
  onImageFileUploaded,
  translation,
} from "../../utils/helper";
import Mantra1_5_canvas from "../Mantra1/mantra1_5_canvas";
import Loader from "../loader/loader";
import swal from "sweetalert";
import NativeShare from "../common/NativeShare";
import { showCongratulations } from "../../utils/misc";
import DownloadBtnCommon from "../common/DownloadBtn";
var EXIF = require("exif-js/exif.js");

class UploadFile extends React.Component {
  constructor() {
    super();
    this.state = {
      image: null,
      festival: null,
      name:
        userDetailStore.getState().userDetail &&
        userDetailStore.getState().userDetail["user_name_display"],
      canvas_image: null,
      preview: false,
      defaultName:
        userDetailStore.getState().userDetail &&
        userDetailStore.getState().userDetail["user_name_display"],
      isLoading: false,
    };
  }

  readFile = (e) => {
    if (!this.name.value) {
      alert("Please enter name.")
      return false;

    }
    var ref = this;
    var input = e.target;
    e.persist();
    if (!$(".loaderMain").is(":visible")) {
      $(".loaderMain").fadeIn();
    }
    if (this.state.userData == null && false) {
      setTimeout(function () {
        ref.readFile(e);
      }, 1000);

      return false;
    }

    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var image = new Image();
        var input_src = e.target.result;

        image.onload = function (imageEvent) {
          var orientation_do = 0;
          EXIF.getData(image, function () {
            var orientation = EXIF.getTag(this, "Orientation");
            if (typeof orientation != "undefined") {
              orientation_do = orientation;
            }
          });

          // Resize the image
          var canvas = document.createElement("canvas"),
            max_size = 1200, // TODO : pull max size from a site config
            width = image.width,
            height = image.height;
          if (width > height) {
            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }
          } else {
            if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
          }
          // alert(orientation_do);
          if (orientation_do == 6 || orientation_do == 8) {
            canvas.width = height;
            canvas.height = width;
          } else {
            canvas.width = width;
            canvas.height = height;
          }

          var ctx = canvas.getContext("2d");

          ctx.drawImage(image, 0, 0, width, height);

          if (canvas.width > canvas.height) {
            ref.setState({ orientation: "frame_1" }); //landscape
          } else {
            ref.setState({ orientation: "frame_2" }); //portrait
          }

          var dataUrl = canvas.toDataURL("image/jpeg");

          var resizedImage = dataURLToBlob(dataUrl);
          ref.setState({
            image: URL.createObjectURL(resizedImage),
            cropper: true,
            resizedImage: resizedImage,
            windowHeight: $(window).height(),
            croppedImage: null,
            currentSection: "SectionCrop",
          });
          // ref.handleChange(); // for validation
        };

        image.src = input_src;
      };

      reader.readAsDataURL(input.files[0]);
      //now we initiate upload without showing any loading to user
    }
  };
  componentDidMount() {

    userDetailStore.subscribe(() => {

      this.setState({
        name:
          userDetailStore.getState().userDetail &&
          userDetailStore.getState().userDetail["user_name_display"],
        defaultName:
          userDetailStore.getState().userDetail &&
          userDetailStore.getState().userDetail["user_name_display"],
      })
    })
  }

  setCroppedImage(croppedImage, done) {
    this.setState({ croppedImageOutput: croppedImage, cropper: false }, () => {
      this.postData(done);
    });
    // this.handleChange();
  }

  postData = async (done) => {

    this.setState({
      isLoading: true,
    });
    // e.preventDefault();
    if (
      $.trim(this.name.value) != "" &&
      this.state.croppedImageOutput != null
    ) {
      //canvas this means canvas is all set, read the name and festival and generate canvas now
      $(".preloader_mantra").show();
      var ref = this;
      let reqdata = {
        type: ref.props.type,
        module_name: ref.props.module_name,
        fullName: this.name.value,
        croppedImageOutput: this.state.croppedImageOutput,
      };
      let resData = await Html2CanvasFunction(reqdata, done);
      resData.addEventListener("load", function (data) {
        data = resData.response;
        data = JSON.parse(data);
        if (data._resultflag == 1) {


          var imageUrl = data.data.cardimage;
          var id = data.data.id;
          ref.setState(
            {
              shareData: imageUrl,
              canvas_image: imageUrl,
              id: id,
              image: null,
              preview: done ? false : true,
            },
            () => {
              // showCongratulations
              if (done) {

                showCongratulations(id);
              }
            }
          )
        };
        if (done) {

          listApiStore.dispatch({ type: "GET_LIST", data: true });
        }
        setTimeout(() => {
          ref.setState({
            isLoading: false,
          });
          // swal("Post Created successfully.");
          onImageFileUploaded({
            image: imageUrl,
            module: ref.props.module_name,
            postid: id
          });
        }, 1000);
      });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  };

  hideCropper = () => {

    this.setState({
      cropper: false,
    });
  };


  saveData = async () => {
    this.setState({
      isLoading: true,
    });
    let ref = this;
    let reqdata = {
      module_type: ref.props.type,
      module_subtype: ref.props.module_name,
      fullName: this.state.name,
    };

    let data = {
      cardimage: this.state.canvas_image,
      id: this.state.id,
    }

    let req = await processShare(data, reqdata);
    setTimeout(() => {
      ref.setState({
        isLoading: false,
        preview: false,
      });
      swal("Post Created successfully.");
    }, 1000);
    if (req._resultflag == 1) {

      showCongratulations(this.state.id);
    }
  }

  render() {
    let {
      croppedImageOutput,
      cropper,
      canvas_image,
      preview,
      isLoading,
      name,
      festival,
      id,
    } = this.state;
    let { pageData } = this.props;
    // description: "Write a letter addressed to your exam, stating why you are not scared of it."
    // inner_name: "Mantra 2 / Activity 1"
    // inner_text: "Letter to exam"
    let image = canvas_image;
    let text = pageData.description ? pageData.description : "";
    let postid = id;

    if (isLoading) {
      return <Loader />;
    }

    return (
      <div>

        <HomeIcon />
        {!preview && (
          <>
            <div className="container">
              <div className="upload_list">
                <ul>
                  <li>
                    <h6>Name*</h6>
                  </li>
                  {/* <li>
                        <img src="/assets/img/home.png" className="img-fluid" alt="" />
                    </li> */}
                </ul>
                <p>
                  <input
                    type="text"
                    ref={(name) => {
                      this.name = name;
                    }}
                    defaultValue={this.state.defaultName}
                    onChange={(e) => {
                      this.setState({ name: e.target.value });
                    }}
                    placeholder="Name"
                  />
                  {/* <img src="/assets/img/check.png" className="img-fluid" alt="" /> */}
                </p>
                {this.props.pageData && this.props.pageData.second_input && (
                  <p>
                    <input
                      type="text"
                      onChange={(e) => {
                        this.setState({ festival: e.target.value });
                      }}
                      ref={(name) => {
                        this.festival = name;
                      }}
                      placeholder="Name of Festival"
                    />
                  </p>
                )}
              </div>
            </div>


            <div className="share_btn_maindiv">
              <div className="upload_file">
                <img
                  src="/assets/img/uploadbg.jpg"
                  className="img-fluid"
                  alt=""
                />
                <div className="upload_input">
                  <input
                    type="file"
                    ref={(fileReader) => {
                      this.fileReader = fileReader;
                    }}
                    onChange={this.readFile}
                  />

                  <div className="upload_content">
                    <img
                      src="/assets/img/camera.png"
                      className="img-fluid"
                      alt=""
                    />
                    <h4>Click Here</h4>
                    <h5>
                      {this.props.pageData.f_text
                        ? this.props.pageData.f_text
                        : "To Upload Photo"}
                    </h5>
                  </div>
                </div>
              </div>
              <div className="container">

                <NativeShare
                  sharedata={{
                    image,
                    text,
                    postid,
                  }}
                >
                  <div className="share_btn share_btn_position">
                    <button type="button" className="btn" disabled="disabled">
                      Share
                  </button>
                  </div>
                </NativeShare>
              </div>




            </div>
            {
              this.props.pageData && this.props.pageData.f_image &&

              <div className="sampe_preview_sec">
                {this.props.module_name != 'm12b' &&

                  <div className="sample_txt">
                    {
                      this.props.pageData.f_text_new ? this.props.pageData.f_text_new :

                        'SAMPLE'
                    }


                  </div>
                }

                <div className="sample_img">
                  <img
                    src={this.props.pageData.f_image}
                    className="img-fluid"
                    alt=""
                  />

                </div>
                {
                  this.props.pageData.download_btn &&
                  <DownloadBtnCommon pageData={this.props.pageData} module={this.props.module_name}>


                    <div className="dwnload_btn">
                      <button className="btn_f">Download</button>

                    </div>
                  </DownloadBtnCommon >
                }


              </div>
            }
          </>
        )
        }
        {
          cropper && (
            <Mantra1_3
              image={this.state.image}
              setCroppedImage={this.setCroppedImage.bind(this)}
              hideCropper={this.hideCropper}
            />
          )
        }
        {
          preview && canvas_image && (
            <div className="card_content_bg">
              <div className="container">
                <button type="button" className="preview_btn">
                  <div className="m3_p_img_prev">
                    <span>Preview</span>
                  </div>
                </button>
                <div className="img_frame_flex">
                  <div className="card_content">
                    <img
                      src={this.state.canvas_image}
                      className="img-fluid"
                      alt=""
                    />

                    {/* <h6><img src="/assets/img/like.png" className="img-fluid img_like" alt="" /><span>1488</span></h6> */}
                  </div>

                  <div className="img_frame2">
                    <ul>
                      <li>
                        <img
                          src="/assets/img/cross.png"
                          onClick={() => {
                            this.setState({ preview: false });
                          }}
                          className="img-fluid"
                          alt=""
                        />
                      CANCEL
                      </li>
                      <li>
                        <img onClick={() => {
                          this.setState({ preview: false });
                        }}
                          src="/assets/img/refresh.png"
                          className="img-fluid"
                          alt=""
                        />
                        UNDO
                      </li>
                      <li>
                        <img
                          src="/assets/img/check2.png"
                          onClick={() => {
                            this.setState({ preview: false });
                          }}
                          className="img-fluid"
                          alt=""
                        />
                        DONE
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="pos_rel">
                  <img src="/assets/img/img25.jpg" className="img-fluid" alt="" />
                  <div className="share_btn_position2">
                    <NativeShare
                      sharedata={{
                        image,
                        text,
                        postid,
                      }}
                    >
                      <div className="preview_btn2">
                        <a href="#">Share</a>
                      </div>
                    </NativeShare>
                  </div>
                </div>
              </div>
            </div>

          )
        }


        {
          croppedImageOutput && name && (
            <Mantra1_5_canvas
              image={croppedImageOutput}
              festival_name={festival}
              module_name={this.props.module_name}
              name={name}
            />
          )
        }
      </div >
    );
  }
}

export default UploadFile;
